import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import LowLevelCategories from './components/LowLevelCategories'
import Tour from './Tour'
import mockData from '../../../utils/mockData';
import { signout } from '../../../redux/actions/userActions'

class TourProjectSummary extends React.Component {
  signoutUser() {
    this.props.signout()
    this.props.history.push('/')
  }

  render() {
    const { navigationStyle } = styles
    const highLevelCategory = this.props.match.params.highLevelCategory
    let sortedCategories = []
    let frameworkCategories = mockData.frameworkCategories();

    sortedCategories = frameworkCategories.categories.slice(0);

    return (
      <div className="project-container">
        <Tour />
        <LowLevelCategories
          loaded={true}
          loading={false}
          navigationStyle={navigationStyle}
          categories={sortedCategories}
          flat={false}
          totalControls={
            frameworkCategories.numberOfControls -
            frameworkCategories.numberOfNotApplicableControls
          }
          compliantControlsTotal={0}
          frameworkName={this.props.compliance}
          headingDescription={this.props.description}
          highLevelCategory={highLevelCategory}
          urlFrameworkName={this.props.path}
          frameworkId={this.props.frameworkId}
          parse={this.props.parse}
          layout={this.props.layout}
        />
      </div>
    )
  }
}

const styles = {
  navigationStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    summary: state.controlsData.summary,
    dataLoaded: !state.controlsData.loading
  }
}

export default connect(mapStateToProps, { signout })(withRouter(TourProjectSummary))



// WEBPACK FOOTER //
// ./src/components/tour/compliance/TourProjectSummary.js